import Log from '.';

import LocalLogger from './LocalLogger';

const initializeLogger = (): void => {
  Log.setLogger(new LocalLogger());
};

export default initializeLogger;
